// extracted by mini-css-extract-plugin
export default {"select":"styles_select__GmxOS","select__list":"styles_select__list__YaMa1","select__item":"styles_select__item__AC7h4","select__item_active":"styles_select__item_active__jp40v"};